import React, { useState } from "react";
import { CellTmpl, TitleTmpl, reactFormatter } from "../../../common/Table";
import ActivityDetails from "./ActivityDetails";
import AddEditActivity from "./AddEditActivity";
import { useDeleteActivity, useGetActivities } from "../../../../backend/masters";
import { ActivityType, CalendarType, GetMastersBreadcrumb, Periodicity } from "../Master.constants";
import { useExportActivities } from "../../../../backend/exports";
import BaseList from "../../../common/BaseList";
import { ActivitySchema } from "../../../../models/activity";
import ActivitiesImportModal from "./ActivitiesImportModal";

function Activity() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('Activity'));

    const columns = [
        {
            title: "Activity", field: "name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Type", field: "activity_type",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Periodicity", field: "periodicity",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Calendar Type", field: "calendar_type",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        }
    ]

    const filterConfig = [
        {
            label: 'Type',
            name: 'activity_type_eq',
            options: ActivityType.map((x: any) => {
                return { value: x, label: x };
            })
        },
        {
            label: 'Periodicity',
            name: 'periodicity_eq',
            options: Periodicity.map((x: any) => {
                return { value: x, label: x };
            })
        },
        {
            label: 'Calendar Type',
            name: 'calendar_type_eq',
            options: CalendarType.map((x: any) => {
                return { value: x, label: x };
            })
        }
    ]

    return (
        <BaseList
        fetchData={useGetActivities}
        exportData={useExportActivities}
        deleteData={useDeleteActivity}
        nameAttribute={'name'}
        columns={columns}
        DetailView={ActivityDetails}
        FormView={AddEditActivity}
        modelSchema={ActivitySchema}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        ImportComponent={ActivitiesImportModal}
        filterConfig={filterConfig}
        title="Mastsers - Activities"
      />
    )
}

export default Activity;
